// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XdfF","content":"styles_content__3kbPg"};